export default __webpack_public_path__ + "static/media/white-bottle.ef8555a8.webp";